export default __webpack_public_path__ + "static/media/emptyImage.f289f1f4.gif";